var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('the-header'),_c('div',{staticClass:"body"},[_c('div',{staticClass:"wrapper"},[_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }